import SetupMFATOTP from './SetupMFATOTP'

export default SetupMFATOTP
